import React, { useState, useRef, useEffect } from 'react';

const WebcamTest = () => {
  const [webcamStream, setWebcamStream] = useState(null);
  const [error, setError] = useState(null);
  const videoRef = useRef(null);

  const startWebcam = async () => {
    try {
      setError(null);
      console.log('Requesting webcam access...');
      
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      
      console.log('Webcam access granted');
      setWebcamStream(stream);
    } catch (err) {
      console.error('Error accessing webcam:', err);
      setError(`Error accessing webcam: ${err.message || err.toString()}`);
    }
  };

  const stopWebcam = () => {
    if (webcamStream) {
      webcamStream.getTracks().forEach(track => track.stop());
      setWebcamStream(null);
    }
  };

  useEffect(() => {
    if (webcamStream && videoRef.current) {
      videoRef.current.srcObject = webcamStream;
      videoRef.current.play().catch(err => {
        console.error('Error playing video:', err);
        setError(`Error playing video: ${err.message || err.toString()}`);
      });
    }
    
    return () => {
      stopWebcam();
    };
  }, [webcamStream]);

  return (
    <div style={{ padding: '20px' }}>
      <h1>Webcam Test</h1>
      
      {!webcamStream ? (
        <div>
          <button 
            onClick={startWebcam}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Start Webcam
          </button>
          {error && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {error}
            </div>
          )}
        </div>
      ) : (
        <div>
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              width: '100%',
              maxWidth: '640px',
              border: '2px solid #ccc',
              borderRadius: '4px'
            }}
          />
          <button 
            onClick={stopWebcam}
            style={{
              marginTop: '10px',
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Stop Webcam
          </button>
        </div>
      )}
    </div>
  );
};

export default WebcamTest;